import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/cote-azur/chauffeur-cote-azur.png";

const frenchRiviera: ChauffeurPage = {
  slug: "french-riviera",
  title: "Private chauffeur French Riviera – VTC",
  subtitle: "Departures from Cannes to Nice, Monaco, Antibes, Saint-Tropez.",
  keywords: ["chauffeur french riviera", "vtc french riviera"],
  hero: {
    title: "Private chauffeur on the French Riviera",
    subtitle: "From Nice to Saint-Tropez, premium travel.",
    keywords: ["Cannes chauffeur", "Nice chauffeur", "Monaco chauffeur"],
    imageSrc: heroImage.src,
    imageAlt: "Private chauffeur on the French Riviera",
    badges: ["Local knowledge", "Partner network", "24/7 support"],
  },
  benefits: {
    heading: "Your benefits on the Riviera",
    items: [
      {
        title: "Local knowledge",
        description: "Fast routes, points of interest.",
      },
      {
        title: "Partner network",
        description: "Reliable vehicles and chauffeurs.",
      },
      { title: "24/7 support", description: "Fast reply and tracking." },
    ],
  },
  services: {
    heading: "Services on the French Riviera",
    services: [
      {
        title: "Transfers",
        text: "Airports, stations, ports – from Cannes to Nice, Monaco.",
      },
      { title: "Events", text: "Shuttles, roadshows, VIP." },
    ],
  },
  locations: {
    heading: "Cities served",
    items: [
      { name: "Nice" },
      { name: "Monaco" },
      { name: "Cannes" },
      { name: "Antibes" },
      { name: "Italian Riviera" },
      { name: "Milan" },
    ],
  },
  generic: {
    heading: "Your chauffeur on the Riviera",
    subheading: "Based in Cannes, optimised routes and guaranteed comfort.",
    paragraphs: [
      "We know Cannes and its Riviera connections inside out to build reliable routes, even on packed days.",
      "This service covers inter-city travel, business meetings and leisure itineraries with the same level of demand.",
      "Depending on your agenda, we adjust pick-up times and points to keep a smooth experience.",
    ],
    bullets: ["FR/EN", "Water & chargers", "On-board Wi-Fi"],
  },
  process: {
    heading: "Inter-city travel on the French Riviera",
    steps: [
      "Collect the day's addresses, times and priorities.",
      "Build an optimised route between cities and points of interest.",
      "Validate the timing with a safety margin.",
      "Chauffeur execution with tracking to the last stop.",
    ],
  },
  faq: [
    {
      q: "Can you chain several cities in the same day?",
      a: "Yes, we organise multi-stop routes on the French Riviera with optimised drive times.",
    },
    {
      q: "Does the service cover the Italian Riviera?",
      a: "Yes, on request we can include the Italian Riviera and extensions toward Milan.",
    },
    {
      q: "Does the chauffeur stay available between two meetings?",
      a: "Yes, via an hourly-hire option tailored to your programme.",
    },
  ],
  relatedLinks: [
    {
      label: "Riviera wedding: the car and the guest shuttles",
      href: "/en/chauffeur/wedding-car-cannes",
    },
    { label: "Book a chauffeur in Cannes", href: "/en/chauffeur/cannes" },
    {
      label: "Nice Airport rates and routes",
      href: "/en/chauffeur/airport",
    },
    { label: "Explore private excursions", href: "/en/excursions" },
  ],
  cta: {
    title: "Your private chauffeur",
    text: "We organise your trips to measure.",
    primaryHref: "/contact",
    primaryLabel: "Request a quote",
  },
  seo: {
    title: "Private chauffeur French Riviera – Bespoke car service",
    description:
      "Private chauffeur based in Cannes for the whole French Riviera: transfers, business, events.",
    canonical: "/en/chauffeur/french-riviera",
  },
};

export default frenchRiviera;
